module.exports = __webpack_public_path__ + "static/img/CoTextCorp-Bold.4c75de0.svg";